import { type VueI18nTranslation } from '@experience/i18n';

export function getAvailableFormat(t: VueI18nTranslation) {
  return {
    INDIVIDUAL: {
      label: t('format.individual.label'),
      description: t('format.individual.description'),
      value: 'private,tour_private',
    },
    GROUP: {
      label: t('format.group.label'),
      description: t(t('format.group.description')),
      value: 'group,tour_group',
    },
    MINI_GROUP: {
      label: t('format.minigroup.label'),
      description: t('format.minigroup.description'),
      value: 'minigroup,tour_minigroup',
    },
  } as const;
}

export function getAvailableTourFormat(t: VueI18nTranslation) {
  return {
    INDIVIDUAL: {
      label: t('format.individualTour.label'),
      description: t('format.individualTour.description'),
      value: 'tour_private',
    },
    GROUP: {
      label: t('format.groupTour.label'),
      description: t(t('format.groupTour.description')),
      value: 'tour_group',
    },
    MINI_GROUP: {
      label: t('format.minigroupTour.label'),
      description: t('format.minigroupTour.description'),
      value: 'tour_minigroup',
    },
  } as const;
}
